import Action from '@/gf/components/Action'
import Card from '@/gf/components/Card'
import {
  useCreateStripeAccountMutation,
  useStartStripeOnboardingMutation,
  useStripeSetupQuery,
} from '@/suppliers/_gen/gql'
import useGqlClient from '@/suppliers/hooks/useGqlClient'
import useSession from '@/suppliers/hooks/useSession'
import { useState } from 'react'

const StripeSetup = () => {
  const {
    user: { id: userId },
    store: { id: storeId },
    featureFlags,
  } = useSession()

  const [creatingStripeAccount, setCreatingStripeAccount] = useState(false)
  const [startingStripeOnboarding, setStartingStripeOnboarding] = useState(false)
  const client = useGqlClient()
  const queryResult = useStripeSetupQuery({ variables: { userId }, client })
  const [createStripeAccountMutation] = useCreateStripeAccountMutation({ client })
  const [startStripeOnboardingMutation] = useStartStripeOnboardingMutation({ client })
  const store = queryResult.data?.store

  if (!store || !featureFlags.stripeSetup) return null

  const startStripeOnboarding = () => {
    setStartingStripeOnboarding(true)
    const { origin, pathname } = window.location

    startStripeOnboardingMutation({
      variables: {
        storeId,
        refreshUrl: `${origin}${pathname}?stripe-refresh=1`,
        returnUrl: `${origin}${pathname}?stripe-return=1`,
      },
    }).then(({ data }) => {
      if (data?.startStripeOnboarding) window.location.href = data.startStripeOnboarding // onboarding URL
    })
  }

  const createStripeAccount = () => {
    setCreatingStripeAccount(true)

    createStripeAccountMutation({ variables: { storeId } }).then(() => {
      startStripeOnboarding()
      queryResult.refetch()
    })
  }

  return (
    <Card title="Stripe Setup">
      <Card.Section>
        {store.stripeAccountId ? (
          <div className="space-y-2">
            <Action.T onClick={startStripeOnboarding} className="flex gap-1 items-center">
              <span>Update Stripe Account</span>

              {startingStripeOnboarding && (
                <div className="animate-spin-slow border-t-blue-500 rounded-full border-2 border-gray-200 h-4 w-4 shrink-0" />
              )}
            </Action.T>
          </div>
        ) : (
          <div className="space-y-4">
            <p className="text-sm">Gearflow partners with Stripe for secure payments.</p>

            <div>
              <Action.P onClick={createStripeAccount} performing={creatingStripeAccount}>
                Setup Stripe Account
              </Action.P>
            </div>
          </div>
        )}
      </Card.Section>
    </Card>
  )
}

export default StripeSetup
